import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { SplitEditorState } from '../split-editor-model';
import type { SplitEditorModel } from '../split-editor-model';

@injectable()
export class SplitEditorModelImpl extends AbstractModel<SplitEditorState> implements SplitEditorModel {
    protected _modelData: SplitEditorState = {
        editingParagraph: undefined,
    };

    override get modelData() {
        return this._modelData;
    }
}
